'use client';

import type React from 'react';
import styled from 'styled-components';
import isPropValid from '@emotion/is-prop-valid';
import type { BoxStyleOptions } from './box-styles';
import { boxStyles } from './box-styles';

export type BoxProps = BoxStyleOptions &
  React.DetailedHTMLProps<
    React.HTMLAttributes<HTMLDivElement>,
    HTMLDivElement
  > & {
    css?: any;
  };

export const Box = styled.div.withConfig({
  shouldForwardProp: (propKeyname) =>
    propKeyname !== `display` &&
    propKeyname !== `color` &&
    isPropValid(propKeyname),
})<BoxProps>`
  ${boxStyles}
`;
